import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaGithub, FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { Home, Info, Layers, Mail, MessageSquare, PenLine } from 'lucide-react';
import { Container, PillButton } from '../home/ui';
import { isActivePath } from '../navbar/Navbar';

const year = new Date().getFullYear();

const socials = [
  { label: 'GitHub', href: 'https://github.com/devBinud', icon: <FaGithub className="w-4 h-4" /> },
  { label: 'LinkedIn', href: 'https://linkedin.com/in/binudpanging', icon: <FaLinkedinIn className="w-4 h-4" /> },
  { label: 'Twitter', href: 'https://x.com/binudp_dev', icon: <FaXTwitter className="w-4 h-4" /> },
  { label: 'Email', href: 'mailto:binudp.dev@gmail.com', icon: <Mail className="w-4 h-4" /> },
];

const navigation = [
  { path: '/', label: 'Home', icon: Home },
  { path: '/about', label: 'About', icon: Info },
  { path: '/services', label: 'Services', icon: Layers },
  { path: '/blog', label: 'Blog', icon: PenLine },
  { path: '/contact', label: 'Contact', icon: MessageSquare },
];

const Footer = () => {
  const { pathname } = useLocation();

  return (
    <footer className="relative overflow-hidden bg-[#0b2471] text-white">
      {/* Soft lighter edges like the reference */}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(75%_85%_at_45%_45%,transparent_55%,rgba(126,146,214,0.55)_100%)]" />

      <Container className="relative pt-20 pb-8">
        <h2 className="text-[34px] sm:text-[44px] font-medium leading-[1.08] tracking-[-0.04em] text-white">
          Ready To Start
          <br />
          Something Great?
        </h2>
        <PillButton to="/contact" variant="light" className="mt-7">
          Book a Call
        </PillButton>

        <nav className="mt-14 grid grid-cols-2 sm:flex sm:flex-wrap gap-3 sm:gap-4">
          {navigation.map(({ path, label, icon: Icon }) => {
            const active = isActivePath(pathname, path);
            return (
              <Link
                key={path}
                to={path}
                className={`sm:w-[180px] rounded-2xl px-5 py-4 flex flex-col gap-4 transition-colors ${
                  active
                    ? 'bg-[#f4f6fa] text-[#111]'
                    : 'border border-white/40 text-white hover:bg-white/10'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="text-lg font-medium tracking-[-0.02em]">{label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="mt-12 h-px bg-white/20" />

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-6 text-sm">
          <p className="text-white/85 text-center md:text-left">
            Designed &amp; Developed By Binud Panging
            <span className="block text-xs text-white/55 mt-1">
              Freelance software, web &amp; mobile app developer · Guwahati, Assam, India
            </span>
          </p>
          <div className="flex items-center gap-2.5">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-10 h-10 rounded-full bg-[#eef1fb] text-[#111] flex items-center justify-center transition-transform hover:-translate-y-0.5"
              >
                {s.icon}
              </a>
            ))}
          </div>
          <div className="flex items-center gap-5 text-white/85">
            <a href="https://binudsoftwaresolutions.in" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              Binud Software Solutions
            </a>
            <span>© {year}</span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
